<template>
    <div v-if="!examInfo" id="manageClass">
        <div class="allBodyDiv">
            <div style="margin-top: 15px">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>自测记录</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div v-if="zhanshi">
                <el-row v-for="i in list" :key="i.id">
                    <el-col :span="24" style="cursor: pointer">
                        <div class="selfTest" style="cursor: auto">
                            <div style="cursor: pointer" @click="$router.push({ path: '/storeexamstatistics', query: { plan: i.course_id,id:i.id,time:i.avg_timelength,num:i.test_num}})">
                              <div class="imgDiv" :style="{textAlign: 'center', backgroundImage: `url(${i.img_url})`, backgroundPosition: 'center', backgroundSize: 'cover'}">
                                <!-- <img height="100%" :src="i.img_url" alt=""> -->
                              </div>
                              <div class="titleDiv">
                                <h2>{{i.exam_name}}</h2>
                                <span></span><br>
                                <span style="color: #babbc1;font-size: 12px;display: inline-block;margin-top: 30px">自测时间：{{i.addtime}}</span>
                              </div>
                            </div>
                            <div class="againBtn">
                                <a href="javascript:(0)" @click="goExam(i)">
                                    <el-button>重新测试</el-button>
                                </a>
                            </div>
                            <div style="cursor: pointer" class="numDiv" @click="$router.push({ path: '/storeexamstatistics', query: { plan: i.course_id,id:i.id,time:i.avg_timelength,num:i.test_num,name:i.exam_name}})">
                                <h1 v-if="i.score>60">{{i.score}}分</h1>
                                <h1 v-else style="color:#ee675a;">{{i.score}}分</h1>
                                <span>最新成绩</span>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <el-row v-else style="width:300px;height:250px;line-height:250px;text-align:center;margin:auto">
                你暂无提交记录
            </el-row>
        </div>
    </div>
  <entexam v-else ref="toexam" @goBack="examInfo = false"></entexam>
</template>
<script>
    import{
        gettestexam,
      getexpertestinfo
    }from'./../../api/exam_api'
    import EntExam from './entExam.vue'
    export default {
      components:{
        entexam:EntExam
      },
        data() {
            return{
                list:[],
                zhanshi:true,
              examInfo:false,
              AppConfig:{
                BASE_URL: 'https://imgcdn.nobook.com/exam/resource/addicomponents/v11/',
              }
            }
        },
        methods:{
            getList(){
              getexpertestinfo({ packageId: this.GLOBAL.productId }).then((res)=>{
                if(res.code == 200){
                  let _examList = res.data;
                  gettestexam({productid:this.GLOBAL.productId,perPage:100000, "sp[0][col]": "subject_id", "sp[0][op]": "=", "sp[0][val]": this.GLOBAL.subjectId}).then((res)=>{
                    if(res.code==200){
                      if(res.data.data.length<=0){
                        this.zhanshi=false;
                        return false
                      }
                      let that = this;
                      res.data.data.forEach(function(index,i){
                        _examList.forEach(function(item,a){
                          if(item.relation_id == index.course_id){
                            index.exam_name = item.name;
                            index.img_url =
                              that.AppConfig.BASE_URL + 'assets/' + (item.subjectid == 1?'physics':'chemistry')+ '/' + item.thumbnail;
                          }
                        });
                        index.addtime=that.GLOBAL.request.toTime(index.addtime * 1000,1);
                        let s='',m='',h='';
                        if(index.avg_timelength==60){
                          index.avg_timelength='1分钟';
                        }else if(index.avg_timelength>60&&index.avg_timelength<3600){
                          m=Math.floor(index.avg_timelength / 60);
                          s=index.avg_timelength % 60;
                          index.avg_timelength=m+'分' + s + '秒'
                        }else if(index.avg_timelength>=3600){
                          if(index.avg_timelength==3600){
                            index.avg_timelength='1小时'
                          }else{
                            m=Math.floor(index.avg_timelength / 60);
                            h=Math.floor(m / 60);
                            m=m % 60;
                            s=index.avg_timelength % 60;
                            index.avg_timelength=h+'1小时'+m+'分' + s + '秒'
                          }
                        }else if(index.avg_timelength<60){
                          index.avg_timelength=index.avg_timelength+'秒'
                        }
                      });
                      this.list=res.data.data;
                      if(this.$route.query.goback == 1){
                        this.$router.push({ path: '/storeexamstatistics', query: { plan: this.list[0].course_id,id:this.list[0].id,time:this.list[0].avg_timelength,num:this.list[0].test_num,toback:1}})
                      }
                    }
                  });
                }
              });

            },
        //  进入实验
          goExam($data){
              $data.relation_id = $data.course_id;
              $data.subjectid = $data.subject_id;
              this.examInfo = true;
              let that = this;
              setTimeout(()=>{
                that.$refs.toexam.examClick($data,2);
              },100);
          }
        },
        mounted(){
          this.getList()
        }
    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/assets/js/pages/exam/StoreTestRecord.vue